import { useQuery } from '@tanstack/react-query'
import { nursesService, type NurseListItem } from '../services/api/nurses'

export function useNurses() {
  return useQuery({
    queryKey: ['nurses'],
    queryFn: async (): Promise<NurseListItem[]> => {
      const result = await nursesService.list()
      if (!result.success) {
        throw new Error(
          result.message ?? 'Impossible de récupérer la liste des infirmiers'
        )
      }
      return result.data ?? []
    },
    staleTime: 60 * 1000,
  })
}
